document.addEventListener("DOMContentLoaded", (event) => {
  var quick_shop_icon = document.getElementsByClassName("quick_shop_icon");
  var ProductItem = document.getElementsByClassName("ProductItem");

  for(let i=0; i<quick_shop_icon.length; i++) {
    quick_shop_icon[i].addEventListener('click', function() {
        ProductItem[i].classList.add("quick_shop_mobile_active");
    })
  }

 window.addEventListener('touchstart', function(e){   
   var quick_shop_mobile_active = document.getElementsByClassName("quick_shop_mobile_active");
   for(let j=0; j<quick_shop_mobile_active.length; j++){
  if (quick_shop_mobile_active[j].contains(e.target) ){
    // Clicked in box
  } else{
    quick_shop_mobile_active[j].classList.remove("quick_shop_mobile_active");
  }
   }
})
  
});


